import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { MsalService } from '@azure/msal-angular';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { jsPDF } from 'jspdf';
import { saveAs } from 'file-saver';
import { Workbook } from 'exceljs';
import { ReportManagerService } from '../../services/report-manager.service';
import { Observable, Subject, of } from 'rxjs';
import { catchError, takeLast, takeUntil, tap } from 'rxjs/operators';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ManagementApiService, UserUtilityService } from 'src/app/services';
import { ReportApiService } from 'src/app/services/report.api.service';
import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { CustomDateAdapter } from 'src/app/Modules/idms/core/custom-date-adapter';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { ActivityProgressData, DashboardResponse } from '../../models/report.model';
import { DxDataGridComponent } from 'devextreme-angular';
import { ReportList } from 'src/app/Modules/informate/models/reports/data-sheet-report.model';
import { Projects } from '../../../project-manager/models/project.model';
@Component({
    selector: 'app-view-report',
    templateUrl: './view-report.component.html',
    styleUrls: ['./view-report.component.scss'],
    providers: [{ provide: DateAdapter, useClass: CustomDateAdapter }],
})
// { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
export class ViewReportComponent implements OnInit, OnDestroy {
    @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
    @Input() currentReport: ReportList;
    @Input() reportName: string;
    destroy$ = new Subject();

    public pageSize = 15;
    public currentPage = 0;
    public totalSize = 0;
    columns: any[] = [];
    datasource: any[] = [];
    currentOrg: string;
    currentInstance: string;
    accountName: string = '';

    projects: any[];
    workpacks: any[];
    activityPacks: any[];
    projectsCopy: any[];
    workpacksCopy: any[];
    activityPacksCopy: any[];
    IsActivityPack: boolean = false;
    activityPackTypes: any[];
    activityPackTypesCopy: any[];
    activityPackStatus: any[];
    activityPackStatusCopy: any[];
    Views: any[];
    ViewsCopy: any[];
    customDataSource: any; //DataSource
    checkedIds: any;
    pageNumber: number = 1;
    pageIndex: number = 0;
    p: number = 1;
    startIndex: number = 1;
    endIndex: number = 15;
    totalCount: number = 0;
    enableReport: boolean = false;
    DefaultValues: any;
    activityPackTypeId: string;
    activityPackStatusIds: any;
    activityPackIds: string;
    fromDate: string;
    projectTypesCopy: any[];
    projectTypes: any[];
    ActivityProgressData: ActivityProgressData;
    jccReportform: UntypedFormGroup;
    initialLoad: boolean = true;
    tooltip_position = 'above';
    formats: any = [];
    allowedKeys = [];
    filteredFormats: string[] = [];
    isExport: boolean = false;
    dashboardData: any;
    activityPackId: string;
    projectsList: Projects[];
    inspectionData = [
        {
            jointId: 'JT-001',
            classValue: 'A',
            classIsCorrect: true,
            classActual: 'A',
            sizeValue: '10 inch',
            sizeIsCorrect: false,
            sizeActual: '12 inch',
            comments: 'Size mismatch',
        },
        {
            jointId: 'JT-002',
            classValue: 'B',
            classIsCorrect: true,
            classActual: 'B',
            sizeValue: '8 inch',
            sizeIsCorrect: true,
            sizeActual: '8 inch',
            comments: '',
        },
    ];
    packSheetprojectsCopy: any;
    packSheetprojects: any;
    packSheetWorkPacks: any;
    packSheetWorkPacksCopy: any;
    activityPackIddrps: string;
    projectIds: string;
    constructor(
        private authService: MsalService,
        private reportManagerService: ReportManagerService,
        private formBuilder: FormBuilder,
        private user_utlity: UserUtilityService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private reportApiService: ReportApiService,
        private cd: ChangeDetectorRef,
        private mgmtApi: ManagementApiService
    ) {}

    ngOnInit(): void {
        this.initialization();
        this.handleSubscription();
        this.LoadFileTye();
    }

    initialization(): void {
        if (localStorage.getItem('selectedOrganizationName')) {
            this.currentOrg = localStorage.getItem('selectedOrganizationName');
        }
        if (localStorage.getItem('currentInstanceName')) {
            this.currentInstance = localStorage.getItem('currentInstanceName');
        }
        if (localStorage.getItem('msal.accessToken')) {
            this.accountName = this.authService.instance.getActiveAccount().idTokenClaims.name;
            //Case of demo user, name will be unknown, so construct the name using surname and firstname
            if (this.accountName === 'unknown') {
                if (this.authService.instance.getActiveAccount().idTokenClaims?.surname) {
                    this.accountName =
                        this.authService.instance.getActiveAccount().idTokenClaims.surname +
                        ',' +
                        this.authService.instance.getActiveAccount().idTokenClaims.firstname;
                } else {
                    this.accountName =
                        this.authService.instance.getActiveAccount().idTokenClaims.family_name +
                        ',' +
                        this.authService.instance.getActiveAccount().idTokenClaims.given_name;
                }
            }
        }
        this.jccReportform = this.formBuilder.group({
            selectAll: new FormControl(false),
            activityPackTypeId: new FormControl(this.reportName == 'Work Flow Completion' ? [] : '-1'),
            viewId: new FormControl([]),
            activityPackId: new FormControl('-1'),
            activityPackTypeStatusId: new FormControl('-1'),
            activityPackTypeStatusselectAll: new FormControl(false),
            activityPackIdselectAll: new FormControl(false),
            from_date: new UntypedFormControl(''),
            projectTypeId: new FormControl(''),
            projectId: new FormControl(''),
            activityPackIddrp: new FormControl(''),
            activityPackIddrpselectAll: new FormControl(false),
            projectIds: new FormControl(''),
            projectIdselectAll: new FormControl(false),
        });
    }
    LoadFileTye() {
        this.mgmtApi.getFileTypes().subscribe(
            (result) => {
                if (result.response?.length > 0) {
                    this.formats = result.response;
                    this.allowedKeys = this.currentReport.supportedFileTypes;
                    this.filteredFormats = this.formats
                        .filter((f) => this.allowedKeys.includes(f.key)) // filter based on allowedKeys
                        .map((f) => {
                            // Map each item and attach the corresponding extension
                            let ext = '';
                            switch (f.value.toLowerCase()) {
                                case 'excel':
                                    ext = 'xlsx';
                                    break;
                                case 'pdf':
                                    ext = 'pdf';
                                    break;
                                case 'json':
                                    ext = 'json';
                                    break;
                            }
                            return ext;
                        });
                }
            },
            (error) => {
                console.error('Error fetching data:', error);
            }
        );
    }
    // minDateStart: any = new Date();
    detectValueChanges(event: MatDatepickerInputEvent<Date>) {
        const selectedDate = event.value;
        this.fromDate = this.formatDate(selectedDate);
        if (this.activityPackIds) {
            this.datasource = [];
            this.customDataSource = null;
            this.enableReport = true;
            this.genrateReport();
        } else {
            this.datasource = [];
            this.customDataSource = null;
            this.enableReport = false;
        }
    }

    private formatDate(date: Date): string {
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
    }

    handleSubscription(): void {
        this.reportManagerService.selectedReportName.pipe(takeUntil(this.destroy$)).subscribe(async (res) => {
            if (res) {
                this.reportName = res;
                switch (this.reportName) {
                    case 'Work Flow Completion':
                        this.getAllActivityPacks();
                        break;
                    case 'View Hierarchy':
                        this.getAllViews();
                        break;
                    case 'Pipe Specifications':
                        this.enableReport = true;
                        this.genrateReport();
                        break;
                    case 'Work Flow Template':
                        this.getAllActivityPacks();
                        break;
                    case 'All Joint Details':
                        this.enableReport = true;
                        this.genrateReport();
                        break;
                    case 'Activity Progress':
                        this.getProjectTypesAndProjects();
                        break;
                    case 'Dashboard':
                        this.LoadCustomDashBoard();
                        break;
                    case 'Pack Sheet':
                        this.getProjects();
                        break;
                    case 'ITP Status':
                        this.enableReport = true;
                        this.genrateReport();
                        break;
                }
                this.cd.detectChanges();
            }
        });

        this.jccReportform
            .get('activityPackTypeId')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .pipe(
                tap((x) => (x.length !== this.activityPackTypesCopy.length ? this.jccReportform.get('selectAll').setValue(false, { emitEvent: false }) : null))
            )
            .subscribe((jointIds) => {
                if (this.reportName == 'Work Flow Template') {
                    if (jointIds && jointIds != -1) {
                        this.activityPacks = this.activityPacksCopy = [];
                        this.activityPackStatus = this.activityPackStatusCopy = [];
                        this.jccReportform.get('activityPackTypeStatusselectAll').setValue(false, { emitEvent: false });
                        this.jccReportform.get('activityPackIdselectAll').setValue(false, { emitEvent: false });
                        let activityPackType = {
                            activityPackTypeId: String(jointIds),
                        };
                        this.activityPackTypeId = String(jointIds);
                        this.jccReportform.get('activityPackTypeStatusId').setValue([]);
                        this.getAllActivityStatus(activityPackType);
                    }
                } else {
                    if (jointIds.length > 0 && jointIds != -1) {
                        this.datasource = [];
                        this.customDataSource = null;
                        this.checkedIds = jointIds;
                        this.enableReport = true;
                        this.genrateReport();
                    } else {
                        this.datasource = [];
                        this.customDataSource = null;
                        this.enableReport = false;
                    }
                }
            });

        this.jccReportform
            .get('viewId')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe(async (viewId) => {
                if (viewId) {
                    this.checkedIds = viewId;
                    this.enableReport = true;
                    this.customDataSource = null;
                    this.genrateReport();
                } else {
                    this.customDataSource = null;
                    this.enableReport = false;
                }
            });
        this.jccReportform
            .get('selectAll')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                switch (this.reportName) {
                    case 'Work Flow Completion':
                        this.jccReportform.get('activityPackTypeId').setValue(value ? this.activityPackTypesCopy.map((x) => x.activityPackTypeId) : []);
                        break;
                    case 'View Hierarchy':
                        this.jccReportform.get('viewId').setValue(value ? this.ViewsCopy.map((x) => x.viewId) : []);
                        break;
                }
            });
        this.jccReportform
            .get('activityPackTypeStatusselectAll')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (!value) {
                    this.datasource = [];
                    this.customDataSource = null;
                    this.enableReport = false;
                }
                this.jccReportform.get('activityPackTypeStatusId').setValue(value ? this.activityPackStatusCopy.map((x) => x.activityPackTypeStatusId) : []);
            });
        this.jccReportform
            .get('activityPackTypeStatusId')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .pipe(
                tap((x) =>
                    x.length > 0 && x.length !== this.activityPackStatusCopy.length
                        ? this.jccReportform.get('activityPackTypeStatusselectAll').setValue(false, { emitEvent: false })
                        : null
                )
            )
            .subscribe((jointIds) => {
                this.activityPacks = this.activityPacksCopy = [];
                this.jccReportform.get('activityPackIdselectAll').setValue(false, { emitEvent: false });

                if (jointIds && jointIds != -1 && jointIds?.length != 0) {
                    let activityPackType = {
                        activityPackTypeId: this.activityPackTypeId,
                        activityPackTypeStatusIds: jointIds,
                    };
                    this.activityPackStatusIds = jointIds;
                    this.getAllActivityStatus(activityPackType);
                }
            });

        this.jccReportform
            .get('activityPackIdselectAll')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                this.jccReportform.get('activityPackId').setValue(value ? this.activityPacksCopy.map((x) => x.activityPackId) : []);
            });

        this.jccReportform
            .get('activityPackId')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .pipe(
                tap((x) =>
                    x.length !== this.activityPacksCopy.length ? this.jccReportform.get('activityPackIdselectAll').setValue(false, { emitEvent: false }) : null
                )
            )
            .subscribe((jointIds) => {
                if (jointIds && jointIds != -1) {
                    let date = this.jccReportform.get('from_date').value;
                    if (jointIds.length > 0) {
                        this.datasource = [];
                        this.customDataSource = null;
                        this.activityPackIds = jointIds;
                        this.enableReport = true;
                        this.genrateReport();
                    } else {
                        this.datasource = [];
                        this.customDataSource = null;
                        this.enableReport = false;
                    }
                }
            });

        this.jccReportform
            .get('projectTypeId')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe(async (projectTypeId) => {
                if (projectTypeId) {
                    this.jccReportform.get('projectId').setValue(null);
                    this.ActivityProgressData = null;
                    this.getProjectTypesAndProjects();
                }
            });
        this.jccReportform
            .get('projectId')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe(async (projectId) => {
                if (projectId) {
                    this.getProjectTypesAndProjects();
                }
            });
        this.jccReportform
            .get('projectIds')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .pipe(
                tap((x) =>
                    x.length !== this.packSheetprojectsCopy.length ? this.jccReportform.get('projectIdselectAll').setValue(false, { emitEvent: false }) : null
                )
            )
            .subscribe((jointIds) => {
                if (jointIds && jointIds != -1) {
                    this.packSheetWorkPacks = this.packSheetWorkPacksCopy = [];
                    this.jccReportform.get('activityPackIddrp').setValue([]);
                    if (jointIds.length > 0) {
                        this.projectIds = jointIds;
                        this.LoadActivityPack(jointIds);
                    } else {
                        this.projectIds = null;
                    }
                }
            });
        this.jccReportform
            .get('activityPackIddrp')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .pipe(
                tap((x) =>
                    x.length !== this.packSheetWorkPacksCopy.length
                        ? this.jccReportform.get('activityPackIddrpselectAll').setValue(false, { emitEvent: false })
                        : null
                )
            )
            .subscribe((jointIds) => {
                if (jointIds && jointIds != -1) {
                    if (jointIds.length > 0) {
                        this.activityPackIddrps = jointIds;
                        this.generatePackSheet(jointIds);
                    } else {
                        this.datasource = [];
                        this.customDataSource = null;
                        this.enableReport = false;
                    }
                }
            });
        this.jccReportform
            .get('activityPackIddrpselectAll')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                this.jccReportform.get('activityPackIddrp').setValue(value ? this.packSheetWorkPacksCopy.map((x) => x.activityPackId) : []);
            });
        this.jccReportform
            .get('projectIdselectAll')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                this.jccReportform.get('projectIds').setValue(value ? this.packSheetprojectsCopy.map((x) => x.projectId) : []);
            });
    }

    MoveToReports(): void {
        this.reportManagerService.isReportSelected.next('mainCard');
    }

    async onExporting(e) {
        e.cancel = true; // Prevent default export

        switch (e.format) {
            case 'pdf':
                const columnWidths = this.columns.map((column) => column.width * 0.6);
                const doc = new jsPDF('l', 'pt');
                doc.setFontSize(14);
                exportDataGridToPdf({
                    jsPDFDocument: doc,
                    component: e.component,
                    columnWidths: columnWidths,
                    loadPanel: {
                        enabled: false,
                    },
                    customizeCell: ({ gridCell, pdfCell }) => {
                        pdfCell.wordWrapEnabled = true; // ensure text wraps in the cell
                        // }
                        pdfCell.padding.top = 3; // add padding for better readability
                        pdfCell.font.size = 7; // set font size to 7
                    },
                }).then(() => {
                    doc.save(`${this.reportName}.pdf`);
                });
                break;

            case 'xlsx':
                this.isExport = true;
                this.ngxUiLoaderService.start();

                const chunkSize = 20000;
                let totalRecords = this.totalCount; // Ensure this is dynamically set before export
                if (!totalRecords || totalRecords <= 0) {
                    return;
                }

                let totalChunks = Math.ceil(totalRecords / chunkSize);
                let allData: any[] = [];

                try {
                    // **Collect API Calls Dynamically**
                    let requests = Array.from({ length: totalChunks }, (_, i) => {
                        let start = i * chunkSize;
                        if (i > 0) {
                            start = i * chunkSize + 1;
                        }
                        let end = Math.min(start + chunkSize, totalRecords);
                        if (i > 0) {
                            end = Math.min(start + chunkSize - 1, totalRecords);
                        }
                        let payload: any = { start, end, viewId: this.jccReportform.get('viewId').value };

                        if (this.reportName == 'View Hierarchy') {
                            return this.getLastValue(this.GetReport(payload, 'getviewhierarchy'));
                        } else if (this.reportName == 'Pipe Specifications') {
                            return this.getLastValue(this.GetReport(payload, 'getpipespecs'));
                        } else if (this.reportName == 'ITP Status') {
                            return this.getLastValue(this.GetReport(payload, 'getitpstatusjazan'));
                        } else {
                            if (this.reportName == 'Work Flow Completion') {
                                payload['activityPackTypeIds'] = this.checkedIds;
                            }
                            if (this.reportName == 'Work Flow Template') {
                                if (this.fromDate) {
                                    payload = {
                                        activityPackTypeId: this.activityPackTypeId,
                                        activityPackTypeStatusIds: this.activityPackStatusIds,
                                        activityPackIds: this.activityPackIds,
                                        from: this.fromDate,
                                    };
                                } else
                                    payload = {
                                        activityPackTypeId: this.activityPackTypeId,
                                        activityPackTypeStatusIds: this.activityPackStatusIds,
                                        activityPackIds: this.activityPackIds,
                                    };
                            }
                            return this.getLastValue(this.GetReport(payload, `get${this.reportName.replace(/\s/g, '').toLocaleLowerCase()}`));
                        }
                    });

                    // **Wait for all API calls to complete**
                    const responses = await Promise.all(requests);

                    // **Merge all responses**
                    responses.forEach((response, index) => {
                        if (response?.data?.length) {
                            allData = [...new Set([...allData, ...response.data])];
                        }
                    });
                } catch (error) {
                    this.ngxUiLoaderService.stop();
                    console.error('Error during export:', error);
                    this.isExport = false;
                }

                // **Ensure Data is Present Before Creating XLSX**
                if (allData.length > 0) {
                    const workbook = new Workbook();
                    const worksheet = workbook.addWorksheet(this.reportName);

                    // **Dynamically Set Columns**
                    worksheet.columns = Object.keys(allData[0]).map((key) => ({
                        header: key,
                        key: key,
                        width: 20,
                    }));

                    // **Insert Data Rows**
                    allData.forEach((row) => worksheet.addRow(row));

                    // **Export XLSX**
                    const buffer = await workbook.xlsx.writeBuffer();
                    this.ngxUiLoaderService.stop();
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${this.reportName}.xlsx`);
                    this.isExport = false;
                } else {
                    this.isExport = false;
                    this.ngxUiLoaderService.stop();
                    console.warn('No data received for export.');
                }

                break;

            case 'json':
                this.isExport = true;
                this.ngxUiLoaderService.start();

                const _chunkSize = 20000;
                let _totalRecords = this.totalCount; // Ensure this is dynamically set before export
                if (!_totalRecords || _totalRecords <= 0) {
                    return;
                }

                let _totalChunks = Math.ceil(_totalRecords / _chunkSize);
                let _allData: any[] = [];

                try {
                    // **Collect API Calls Dynamically**
                    let requests = Array.from({ length: _totalChunks }, (_, i) => {
                        let start = i * _chunkSize;
                        if (i > 0) {
                            start = i * _chunkSize + 1;
                        }
                        let end = Math.min(start + _chunkSize, _totalRecords);
                        if (i > 0) {
                            end = Math.min(start + _chunkSize - 1, _totalRecords);
                        }
                        let payload: any = { start, end, viewId: this.jccReportform.get('viewId').value };

                        if (this.reportName == 'View Hierarchy') {
                            return this.getLastValue(this.GetReport(payload, 'getviewhierarchy'));
                        } else if (this.reportName == 'Pipe Specifications') {
                            return this.getLastValue(this.GetReport(payload, 'getpipespecs'));
                        } else if (this.reportName == 'ITP Status') {
                            return this.getLastValue(this.GetReport(payload, 'getitpstatusjazan'));
                        } else {
                            if (this.reportName == 'Work Flow Completion') {
                                payload['activityPackTypeIds'] = this.checkedIds;
                            }
                            if (this.reportName == 'Work Flow Template') {
                                if (this.fromDate) {
                                    payload = {
                                        activityPackTypeId: this.activityPackTypeId,
                                        activityPackTypeStatusIds: this.activityPackStatusIds,
                                        activityPackIds: this.activityPackIds,
                                        from: this.fromDate,
                                    };
                                } else
                                    payload = {
                                        activityPackTypeId: this.activityPackTypeId,
                                        activityPackTypeStatusIds: this.activityPackStatusIds,
                                        activityPackIds: this.activityPackIds,
                                    };
                            }
                            return this.getLastValue(this.GetReport(payload, `get${this.reportName.replace(/\s/g, '').toLocaleLowerCase()}`));
                        }
                    });

                    // **Wait for all API calls to complete**
                    const responses = await Promise.all(requests);

                    // **Merge all responses**
                    responses.forEach((response, index) => {
                        if (response?.data?.length) {
                            _allData = [...new Set([..._allData, ...response.data])];
                        }
                    });
                } catch (error) {
                    this.ngxUiLoaderService.stop();
                    console.error('Error during export:', error);
                    this.isExport = false;
                }
                if (_allData.length > 0) {
                    const jsonContent = JSON.stringify(_allData, null, 2);
                    const blob = new Blob([jsonContent], { type: 'application/json' });
                    const downloadLink = document.createElement('a');
                    downloadLink.href = window.URL.createObjectURL(blob);
                    downloadLink.download = this.reportName.replace(/[^a-zA-Z0-9_\-\.]/g, '_');
                    downloadLink.click();
                    window.URL.revokeObjectURL(downloadLink.href);
                    this.ngxUiLoaderService.stop();
                    this.isExport = false;
                    break;
                } else {
                    this.isExport = false;
                    this.ngxUiLoaderService.stop();
                    console.warn('No data received for export.');
                }
        }
    }

    searchResult(event: any, type: string) {
        const configMap: Record<string, { targetProp: string; sourceProp: string; field: string }> = {
            activityPackTypeId: { targetProp: 'activityPackTypes', sourceProp: 'activityPackTypesCopy', field: 'name' },
            viewId: { targetProp: 'Views', sourceProp: 'ViewsCopy', field: 'name' },
            projectTypeId: { targetProp: 'projectTypes', sourceProp: 'projectTypesCopy', field: 'name' },
            projectId: { targetProp: 'projects', sourceProp: 'projectsCopy', field: 'namePrimary' },
            activityPackId: { targetProp: 'activityPacks', sourceProp: 'activityPacksCopy', field: 'namePrimary' },
            activityPackTypeStatusId: { targetProp: 'activityPackStatus', sourceProp: 'activityPackStatusCopy', field: 'name' },
            projectIds: { targetProp: 'packSheetprojects', sourceProp: 'packSheetprojectsCopy', field: 'namePrimary' },
            activityPackIddrp: { targetProp: 'packSheetWorkPacks', sourceProp: 'packSheetWorkPacksCopy', field: 'namePrimary' },
        };

        const config = configMap[type];
        if (config) {
            (this as any)[config.targetProp] = this.filterList((this as any)[config.sourceProp], event?.target?.value, config.field);
        }
    }

    filterList(data: any[], searchValue: string, field: string): any[] {
        const input = (searchValue || '').trim().replace(/ /g, '').toLowerCase();

        if (!input) return data;

        return data.filter((item) => {
            const value = (item?.[field] || '').trim().toLowerCase().replace(/ /g, '');
            return value.includes(input);
        });
    }

    async getAllActivityPacks() {
        this.ngxUiLoaderService.start();
        try {
            let url = '';
            switch (this.reportName) {
                case 'Work Flow Completion':
                    url = 'getworkflowcompletion';
                    break;
                case 'Work Flow Template':
                    url = 'getworkflowtemplate';
                    break;
            }
            const _ActivityPacks = await this.reportApiService.getAllActivityPacks(url).toPromise();
            if (_ActivityPacks.success) {
                this.activityPackTypes = this.activityPackTypesCopy = _ActivityPacks.response;
                if (this.activityPackTypes?.length == 1) {
                    this.activityPackTypeId = this.activityPackTypes[0].activityPackTypeId;

                    if (this.reportName == 'Work Flow Completion') {
                        // this.jccReportform
                        //     .get('activityPackTypeId')
                        //     .setValue(this.activityPackTypes[0].activityPackTypeId ? this.activityPackTypesCopy.map((x) => x.activityPackTypeId) : []);
                    } else if (this.reportName == 'Work Flow Template') {
                        this.jccReportform.get('activityPackTypeId').patchValue(this.activityPackTypes[0].activityPackTypeId, { emitEvent: true });
                    }
                }
            } else {
                this.user_utlity.errorModelPopup(_ActivityPacks.message);
            }
            this.ngxUiLoaderService.stop();
        } catch (err) {
            this.ngxUiLoaderService.stop();
            this.user_utlity.errorModelPopup(err.err);
        }
    }

    async getAllActivityStatus(activityPackType: any) {
        this.ngxUiLoaderService.start();
        try {
            const Activity_Packs = await this.reportApiService.getAllActivityPacks('getworkflowtemplate', activityPackType).toPromise();
            if (Activity_Packs.success) {
                if (activityPackType?.activityPackTypeStatusIds && activityPackType?.activityPackTypeStatusIds?.length > 0) {
                    this.activityPacks = this.activityPacksCopy = Activity_Packs.response;
                    if (this.activityPacks?.length == 1) {
                        this.jccReportform
                            .get('activityPackId')
                            .setValue(this.activityPacks[0].activityPackId ? this.activityPacksCopy.map((x) => x.activityPackId) : []);
                    }
                } else {
                    this.activityPackStatus = this.activityPackStatusCopy = Activity_Packs.response;
                    if (this.activityPackStatus?.length == 1) {
                        this.jccReportform
                            .get('activityPackTypeStatusId')
                            .setValue(
                                this.activityPackStatus[0].activityPackTypeStatusId ? this.activityPackStatusCopy.map((x) => x.activityPackTypeStatusId) : []
                            );
                    }
                }
            } else {
                this.user_utlity.errorModelPopup(Activity_Packs.message);
            }
            this.ngxUiLoaderService.stop();
        } catch (err) {
            this.ngxUiLoaderService.stop();
            this.user_utlity.errorModelPopup(err.err);
        }
    }

    async getAllViews() {
        this.ngxUiLoaderService.start();
        try {
            const Views = await this.reportApiService.getAllViews().toPromise();
            if (Views.success) {
                this.Views = this.ViewsCopy = Views.response;
                if (this.Views?.length == 1) {
                    this.checkedIds = this.Views[0].viewId;
                    this.totalCount = Views.response[0].total;
                    this.jccReportform.get('viewId').patchValue(this.Views[0].viewId, { emitEvent: true });
                }
            } else {
                this.user_utlity.errorModelPopup(Views.message);
            }
            this.ngxUiLoaderService.stop();
        } catch (err) {
            this.ngxUiLoaderService.stop();
            this.user_utlity.errorModelPopup(err.err);
        }
    }

    async getProjectTypesAndProjects() {
        let projecttypeId = this.jccReportform.get('projectTypeId').value;
        let projectId = this.jccReportform.get('projectId').value;
        let payLoad = {};
        payLoad = projectId && projecttypeId ? { projectId: projectId } : projecttypeId && !projectId ? { projectTypeId: projecttypeId } : payLoad;

        this.ngxUiLoaderService.start();
        try {
            const project_Data = await this.reportApiService.getProjectTypesAndProjects('getactivityprogress', payLoad).toPromise();
            if (project_Data.success) {
                if (!projecttypeId && !projectId) {
                    this.projectTypes = this.projectTypesCopy = project_Data.response;
                    if (this.projectTypes?.length == 1) {
                        this.jccReportform.get('projectTypeId').setValue(this.projectTypes[0].projectTypeId ? this.projectTypes[0].projectTypeId : '');
                    }
                } else if (!projectId && projecttypeId) {
                    this.projects = this.projectsCopy = project_Data.response;
                    if (this.projects?.length == 1) {
                        this.jccReportform.get('projectId').setValue(this.projects[0].projectId ? this.projects[0].projectId : '');
                    }
                } else {
                    this.ActivityProgressData = project_Data.response;
                }
            } else {
                this.user_utlity.errorModelPopup(project_Data.message);
            }
            this.ngxUiLoaderService.stop();
        } catch (err) {
            this.ngxUiLoaderService.stop();
            this.user_utlity.errorModelPopup(err);
        }
    }

    genrateReport() {
        switch (this.reportName) {
            case 'Work Flow Completion':
                this.LoadReport('getworkflowcompletion');
                break;
            case 'Work Flow Template':
                this.LoadReport('getworkflowtemplate');
                break;
            case 'View Hierarchy':
                this.LoadReport('getviewhierarchy');
                break;
            case 'Pipe Specifications':
                this.LoadReport('getpipespecs');
                break;
            case 'All Joint Details':
                this.LoadReport('getalljointdetails');
                break;
            case 'ITP Status':
                this.LoadReport('getitpstatusjazan');
                break;
        }
    }

    LoadReport(reportName: string) {
        const isNotEmpty = (value: unknown) => value !== undefined && value !== null && value !== '';
        let lastRequest: any = null;
        this.customDataSource = new DataSource({
            store: new CustomStore({
                // key: 'ID',
                load: (loadOptions: any) => {
                    //let params: HttpParams = new HttpParams();
                    const currentRequest = JSON.stringify(loadOptions);

                    // Avoid duplicate calls
                    if (currentRequest === lastRequest) {
                        return Promise.resolve({ data: this.datasource, totalCount: this.totalCount });
                    }
                    lastRequest = currentRequest;
                    let skip = loadOptions.skip;
                    let take = loadOptions.take;
                    //let filter = loadOptions.filter ? loadOptions.filter[0].filterValue : '';

                    let startIndex = skip + 1;
                    let endIndex = skip + take;
                    let payload: any = {
                        start: startIndex,
                        end: endIndex,
                    };
                    switch (this.reportName) {
                        case 'Work Flow Completion':
                            payload['activityPackTypeIds'] = this.checkedIds;
                            break;
                        case 'Work Flow Template':
                            if (this.fromDate) {
                                payload = {
                                    start: startIndex,
                                    end: endIndex,
                                    activityPackTypeId: this.activityPackTypeId,
                                    activityPackTypeStatusIds: this.activityPackStatusIds,
                                    activityPackIds: this.activityPackIds,
                                    from: this.fromDate,
                                };
                            } else
                                payload = {
                                    start: startIndex,
                                    end: endIndex,
                                    activityPackTypeId: this.activityPackTypeId,
                                    activityPackTypeStatusIds: this.activityPackStatusIds,
                                    activityPackIds: this.activityPackIds,
                                };
                            break;
                        case 'View Hierarchy':
                            payload['viewId'] = this.checkedIds;
                            break;
                        case 'All Joint Details':
                            if (loadOptions?.isLoadingAll) {
                                payload = {};
                            }
                            break;
                    }
                    return this.getLastValue(this.GetReport(payload, reportName))
                        .then((response: any) => {
                            if (response?.data?.length > 0) {
                                this.datasource = response?.data;
                                this.totalCount = response.totalCount ? response.totalCount : response.total;
                                this.enableReport = true;
                            } else {
                                this.enableReport = false;
                                this.datasource = [];
                            }
                            return {
                                data: response?.data,
                                totalCount: response?.totalCount,
                            };
                        })
                        .catch(() => {
                            throw 'Data loading error';
                        });
                },
            }),
        });
    }

    GetReport(reportData, reportType: string): Observable<any> {
        return of(this.Load(reportData, reportType));
    }

    async Load(reportData, reportType: string) {
        this.ngxUiLoaderService.start();
        let resp = await this.reportApiService.getReport(reportData, reportType).pipe(takeUntil(this.destroy$)).toPromise();
        if (resp) {
            if (resp.success) {
                this.totalCount = resp.response.total;
                let data = {
                    data: resp.response.reportData,
                    totalCount: resp.response.total,
                };
                if (this.initialLoad && resp?.response?.reportData?.length > 0) {
                    let headers = Object.keys(resp?.response?.reportData[0]);
                    let columns = [];
                    headers.forEach((item) => {
                        // Get max length from entire dataset
                        let maxLength = Math.max(...resp.response.reportData.map((row) => (row[item] ? row[item].toString().length : 0)));
                        let colLength = item?.length;
                        // If max length is large → assign minWidth
                        let isLongRow = maxLength > 10; // adjust threshold
                        let isLongColumn = colLength > 10; // adjust threshold

                        let column = {
                            caption: item,
                            dataField: item,
                            minWidth: isLongRow || isLongColumn ? 110 : 60,
                            cellTemplate: 'diffCellTemplate',
                        };
                        // let column = { caption: item, dataField: item, width: width, cellTemplate: 'diffCellTemplate' };
                        columns.push(column);
                    });
                    this.columns = columns;
                    this.dataGrid.instance.option('columns', this.columns);
                    this.initialLoad = false;
                    this.dataGrid.loadPanel.enabled = false;
                }
                if (!this.isExport) this.ngxUiLoaderService.stop();
                return data;
            } else {
                this.ngxUiLoaderService.stop();
                this.user_utlity.errorModelPopup(resp.message);
                this.jccReportform.get('selectAll').patchValue(false, { emitEvent: false });
                return null;
            }
        }
    }

    //For rendering UI
    splitData(data) {
        // Remove square brackets and single quotes
        let cleanedValues;
        if (data?.value && String(data?.value).includes('\r\n')) {
            if (this.reportName == 'All Joint Details') {
                cleanedValues = data?.value; //.replace(/\[\"|\"\]/g, '').replace(/","/g, '";"');
                return cleanedValues.split('\r\n');
            } else {
                cleanedValues = data?.value; //.replace(/\[\"|\"\]/g, '');
                let df = cleanedValues.split('\r\n');
                return cleanedValues.split('\r\n');
            }
        } else {
            cleanedValues = data.value;
            // Split by comma and join with newline
            return [];
        }
    }

    replaceSymbols(data) {
        // Remove square brackets and single quotes
        let cleanedValues = data.replace(/"/g, '');
        return cleanedValues;
    }

    getLastValue<T>(observable: Observable<T>): Promise<T | null> {
        return new Promise<T>((resolve, reject) => {
            let lastValue: T | null = null;
            observable
                .pipe(
                    takeLast(1), // Takes only the last emitted value
                    catchError((error) => {
                        // Catch any errors and reject the Promise
                        reject(error);
                        return [];
                    })
                )
                .subscribe({
                    next: (value) => {
                        lastValue = value;
                    },
                    complete: () => {
                        resolve(lastValue); // Resolve the Promise with the last emitted value
                    },
                });
        });
    }

    ExportToPDf() {
        try {
            this.ngxUiLoaderService.start();
            if (this.reportName == 'Dashboard') {
                let rptData = {
                    ReportName: 'JazanCustomReport',
                    JazanCustomReport: this.dashboardData,
                    Formate: 'pdf',
                };
                this.reportApiService.exportReport(rptData).subscribe((response) => {
                    const blob = new Blob([response], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = 'JazanCustomReport.pdf';
                    a.click();
                    window.URL.revokeObjectURL(url);
                    this.ngxUiLoaderService.stop();
                });
            } else {
                let rptData = {
                    ReportName: 'ActivityProgressReport',
                    ActivityProgressReport: this.ActivityProgressData,
                    Formate: 'pdf',
                };
                this.reportApiService.exportReport(rptData).subscribe((response) => {
                    const blob = new Blob([response], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = 'ActivityProgressReport.pdf';
                    a.click();
                    window.URL.revokeObjectURL(url);
                    this.ngxUiLoaderService.stop();
                });
            }
        } catch (err) {
            this.ngxUiLoaderService.stop();
            this.user_utlity.errorModelPopup('Error');
        }
    }

    async getProjects() {
        this.ngxUiLoaderService.start();
        try {
            let payLoad = {};
            this.reportApiService.getpacksheet(payLoad).subscribe(
                (res) => {
                    this.ngxUiLoaderService.stop();
                    if (res.success) {
                        if (res.response) {
                            this.packSheetprojects = this.packSheetprojectsCopy = res.response;
                            if (this.packSheetprojects?.length == 1) {
                                this.jccReportform.get('projectIds').setValue(this.packSheetprojects[0].projectId ? this.packSheetprojects[0].projectId : '');
                            }
                        }
                    } else {
                        this.user_utlity.errorModelPopup(res.message);
                    }
                },
                (err) => this.ngxUiLoaderService.stop()
            );

            // this.projectsList = await this.ProjectmanagerService.getAllProject();
            this.ngxUiLoaderService.stop();
        } catch (err) {
            this.ngxUiLoaderService.stop();
            this.user_utlity.errorModelPopup(err);
        }
    }

    async LoadActivityPack(jointIds?: any) {
        try {
            this.ngxUiLoaderService.start();
            let payLoad = {
                projectIds: jointIds,
            };
            this.reportApiService.getpacksheet(payLoad).subscribe(
                (res) => {
                    this.ngxUiLoaderService.stop();
                    if (res.success) {
                        if (res.response) {
                            this.packSheetWorkPacks = this.packSheetWorkPacksCopy = res.response;
                            if (this.packSheetWorkPacks?.length == 1) {
                                this.jccReportform
                                    .get('activityPackIddrp')
                                    .setValue(this.packSheetWorkPacks[0].activityPackId ? [this.packSheetWorkPacks[0].activityPackId] : []);
                            }
                        }
                    } else {
                        this.user_utlity.errorModelPopup(res.message);
                    }
                },
                (err) => this.ngxUiLoaderService.stop()
            );
        } catch (err) {
            this.ngxUiLoaderService.stop();
            this.user_utlity.errorModelPopup(err);
        }
    }

    async generatePackSheet(jointIds: any) {
        try {
            this.ngxUiLoaderService.start();
            let payLoad = {
                activityPackIds: jointIds,
            };
            this.reportApiService.getpacksheet(payLoad).subscribe(
                (res) => {
                    this.ngxUiLoaderService.stop();
                    if (res.success) {
                        if (res && jointIds.length > 1) {
                            this.ngxUiLoaderService.start();
                            let rptData = {
                                ReportName: 'PackSheetReport',
                                PackSheetData: res.response,
                                Formate: 'pdf',
                            };
                            this.reportApiService.exportMultipleReports(rptData).subscribe((response) => {
                                const blob = new Blob([response], { type: 'application/pdf' });
                                const url = window.URL.createObjectURL(blob);
                                const a = document.createElement('a');

                                window.open(url, '_blank');
                                setTimeout(() => window.URL.revokeObjectURL(url), 1000);

                                this.ngxUiLoaderService.stop();
                            });
                        } else {
                            this.ngxUiLoaderService.start();
                            let rptData = {
                                ReportName: 'PackSheetReport',
                                PackSheetData: res.response,
                                Formate: 'pdf',
                            };
                            this.reportApiService.exportReport(rptData).subscribe((response) => {
                                const blob = new Blob([response], { type: 'application/pdf' });
                                const url = window.URL.createObjectURL(blob);
                                const a = document.createElement('a');

                                window.open(url, '_blank');
                                setTimeout(() => window.URL.revokeObjectURL(url), 1000);

                                this.ngxUiLoaderService.stop();
                            });
                        }
                    } else {
                        this.user_utlity.errorModelPopup(res.message);
                    }
                },
                (err) => this.ngxUiLoaderService.stop()
            );
        } catch (err) {
            this.ngxUiLoaderService.stop();
            this.user_utlity.errorModelPopup(err);
        }
    }

    async LoadCustomDashBoard() {
        this.reportApiService.getdashboardjazan().subscribe(
            (res) => {
                this.ngxUiLoaderService.stop();
                if (res.success) {
                    this.dashboardData = res.response;
                    this.cd.detectChanges();
                } else {
                    this.user_utlity.errorModelPopup(res.message);
                }
            },
            (err) => this.ngxUiLoaderService.stop()
        );
    }
    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
